import React, { useState } from 'react';
import { Tabs, Typography } from 'antd';
import { DashboardOutlined, FileTextOutlined, ExportOutlined } from '@ant-design/icons';
import AnalyticsDashboard from './Dashboard/Dashboard';
import AnalyticsClientReports from './ClientReports/ClientReports';
import AnalyticsExport from './Export/Export';

const { Title } = Typography;

const Analytics = () => {
  const [activeTab, setActiveTab] = useState('dashboard');

  const items = [
    {
      key: 'dashboard',
      label: (
        <span>
          <DashboardOutlined /> Performance Dashboard
        </span>
      ),
      children: <AnalyticsDashboard />
    },
    {
      key: 'client-reports',
      label: (
        <span>
          <FileTextOutlined /> Client Reports
        </span>
      ),
      children: <AnalyticsClientReports />
    },
    {
      key: 'export',
      label: (
        <span>
          <ExportOutlined /> Export Reports
        </span>
      ),
      children: <AnalyticsExport />
    }
  ];

  return (
    <div style={{ padding: '24px' }}>
      <Title level={2}>Analytics & Reports</Title>
      <Tabs
        activeKey={activeTab}
        onChange={setActiveTab}
        items={items}
        size="large"
      />
    </div>
  );
};

export default Analytics;
